import countries from 'i18n-iso-countries';

export const getCountries = (language: string) => {
  return Object.entries(countries.getNames(language, { select: 'all' })).map(
    ([code, names]) => {
      let name = names.at(0);

      if (
        code === 'TR' ||
        code === 'AX' ||
        code === 'TW' ||
        code === 'IR' ||
        code === 'PS'
      ) {
        name = names.at(names.length - 1);
      }

      name ??= '';

      return {
        value: code,
        label: name,
      };
    },
  );
};
